import { Link } from 'react-router-dom';
import { featuredComics } from '@/mocks/comics';

const comicImages: Record<string, string> = {
  'comic-1': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20handsome%20male%20protagonist%20with%20glowing%20spiritual%20energy%20surrounding%20him%20modern%20city%20background%20at%20night%20dramatic%20pose%20golden%20and%20jade%20green%20color%20scheme%20clean%20simple%20background&width=600&height=900&seq=comic-cover-01&orientation=portrait',
  'comic-2': 'https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20cover%20art%20elegant%20CEO%20man%20in%20black%20suit%20and%20beautiful%20woman%20in%20white%20dress%20rose%20petals%20scattered%20romantic%20atmosphere%20pink%20cream%20color%20scheme%20clean%20simple%20background&width=600&height=900&seq=comic-cover-02&orientation=portrait',
  'comic-3': 'https://readdy.ai/api/search-image?query=Korean%20thriller%20webtoon%20cover%20art%20detective%20figure%20in%20dark%20trench%20coat%20standing%20in%20rainy%20alley%20neon%20reflections%20mysterious%20silhouette%20deep%20teal%20and%20crimson%20color%20scheme%20clean%20simple%20background&width=600&height=900&seq=comic-cover-03&orientation=portrait',
  'comic-4': 'https://readdy.ai/api/search-image?query=Korean%20action%20webtoon%20cover%20art%20martial%20artist%20with%20long%20sword%20dramatic%20battle%20stance%20energy%20waves%20surrounding%20fiery%20orange%20and%20gold%20color%20scheme%20clean%20simple%20background&width=600&height=900&seq=comic-cover-04&orientation=portrait',
  'comic-5': 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20webtoon%20cover%20art%20magic%20academy%20student%20casting%20spell%20with%20magic%20circle%20floating%20books%20purple%20and%20gold%20color%20scheme%20clean%20simple%20background&width=600&height=900&seq=comic-cover-05&orientation=portrait',
  'comic-6': 'https://readdy.ai/api/search-image?query=Korean%20comedy%20webtoon%20cover%20art%20group%20of%20high%20school%20students%20laughing%20together%20in%20classroom%20bright%20sunny%20yellow%20color%20scheme%20clean%20simple%20background&width=600&height=900&seq=comic-cover-06&orientation=portrait',
  'comic-7': 'https://readdy.ai/api/search-image?query=Korean%20historical%20webtoon%20cover%20art%20beautiful%20woman%20in%20traditional%20hanbok%20standing%20in%20ancient%20palace%20garden%20soft%20autumn%20leaves%20golden%20beige%20color%20scheme%20clean%20simple%20background&width=600&height=900&seq=comic-cover-07&orientation=portrait',
  'comic-8': 'https://readdy.ai/api/search-image?query=Korean%20horror%20webtoon%20cover%20art%20exorcist%20holding%20talisman%20against%20dark%20spirit%20shadow%20in%20modern%20apartment%20eerie%20green%20glow%20dark%20atmosphere%20clean%20simple%20background&width=600&height=900&seq=comic-cover-08&orientation=portrait',
  'comic-9': 'https://readdy.ai/api/search-image?query=Korean%20healing%20webtoon%20cover%20art%20cozy%20cafe%20barista%20smiling%20behind%20counter%20steaming%20coffee%20warm%20sunlight%20through%20window%20cream%20beige%20color%20scheme%20clean%20simple%20background&width=600&height=900&seq=comic-cover-09&orientation=portrait',
  'comic-10': 'https://readdy.ai/api/search-image?query=Korean%20drama%20webtoon%20cover%20art%20confident%20businesswoman%20in%20office%20attire%20looking%20out%20skyscraper%20window%20city%20skyline%20sunset%20warm%20muted%20teal%20color%20scheme%20clean%20simple%20background&width=600&height=900&seq=comic-cover-10&orientation=portrait',
};

export default function FeaturedGrid() {
  const mainComic = featuredComics[0];
  const sideComics = featuredComics.slice(1, 5);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
              每日精选
            </h2>
            <p className="mt-2 text-sm text-foreground-500">编辑精心挑选，品质保证</p>
          </div>
          <Link
            to="/category/romance"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mainComic && (
            <Link
              to={`/article/${mainComic.id}`}
              className="relative group rounded-lg overflow-hidden bg-foreground-900 cursor-pointer md:row-span-2"
            >
              <div className="absolute inset-0">
                <img
                  src={comicImages[mainComic.id]}
                  alt={mainComic.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
              </div>
              <div className="relative h-full flex flex-col justify-end p-6 min-h-[480px]">
                <span className="inline-block px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium mb-3 whitespace-nowrap">
                  主编推荐
                </span>
                <h3 className="font-heading text-xl md:text-2xl font-bold text-background-50">
                  {mainComic.title}
                </h3>
                <p className="mt-2 text-sm text-background-50/70 line-clamp-2">
                  {mainComic.description}
                </p>
                <div className="mt-3 flex items-center gap-3 text-xs text-background-50/60">
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-accent-400"></i> {mainComic.rating}
                  </span>
                  <span>{mainComic.status}</span>
                  <span>{mainComic.viewCount.toLocaleString()} 阅读</span>
                </div>
              </div>
            </Link>
          )}

          {sideComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group bg-background-100 rounded-lg overflow-hidden hover:bg-background-200/70 transition-colors duration-300 cursor-pointer flex"
            >
              <div className="w-28 md:w-32 shrink-0 overflow-hidden">
                <img
                  src={comicImages[comic.id]}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex-1 p-3 md:p-4 flex flex-col justify-between">
                <div>
                  <span className="inline-block px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-2 whitespace-nowrap">
                    {comic.status}
                  </span>
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 line-clamp-2">
                    {comic.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
                </div>
                <div className="flex items-center gap-2 text-xs text-foreground-400">
                  <span className="flex items-center gap-0.5">
                    <i className="ri-star-fill text-accent-400 text-xs"></i> {comic.rating}
                  </span>
                  <span>更新至 {comic.chapters.length} 章</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}